$(function(){
    $('.copy-text-component').on('click', (e) => {
        e.preventDefault();
        const btn = $(e.currentTarget);
        const text = btn.data('text-to-copy');
        const name = btn.data('copy-btn-name');
        const btnClass = btn.data('copy-btn-class');
        const $temp = $("<input>");

        $("body").append($temp);
        $temp.val(text).select();
        document.execCommand("copy");
        $temp.remove();
        btn.removeClass(btnClass).addClass('text-success font-bold').html('Copied!');
        setTimeout(() => btn.removeClass('text-success font-bold').addClass(btnClass).html(name), 2500);
    })
});


// WEBPACK FOOTER //
// ./app/components/copy_text/component.js